import { spaceCadet, kiwiGreen } from '@cogneed/react-utils';
import {
  Box, alpha, styled,
} from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  border: `1px solid ${spaceCadet[300]}`,
  borderRadius: '4px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'stretch',
  maxWidth: 600,
  '& .MuiTypography-root': {
    textAlign: 'left',
  },

  '& > .MuiBox-root.header': {
    padding: '8px 12px 4px 12px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',

    '& > .MuiTypography-subtitle1': {
      fontSize: 16,
      lineHeight: '20px',
      fontWeight: 700,
    },
    '& .MuiButton-root': {
      minWidth: 0,
      textTransform: 'none',

      '& svg': {
        color: spaceCadet[400],
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shortest,
        }),
        transform: 'rotate(180deg)',
        fontSize: 20,
      },
      '&.collapsed': {
        '& svg': { transform: 'rotate(0deg)' },
      },
    },
  },
  '& .MuiFormControlLabel-root': {
    marginLeft: 0,
    '& .MuiRadio-root': {
      padding: 4,
    },
  },
  '& .MuiTextField-root': {
    '& .Mui-focused': {
      backgroundColor: alpha(spaceCadet[300], 0.5),
    },
  },
  '& .MuiInputBase-inputAdornedEnd': {
    padding: '11.5px 0px 11.5px 14px',
  },
  '& .MuiSelect-select': {
    padding: '11.5px 32px 11.5px 14px',
  },
  '& .MuiTypography-body1.label': {
    fontSize: 13,
    padding: '0px 8px',
  },
  '& .MuiCheckbox-root': {
    padding: 9,
    '& .MuiSvgIcon-root': {
      fontSize: 20,
    },
  },

  '& .MuiBox-root.fields': {
    backgroundColor: alpha(spaceCadet[100], 1.0),
    border: `medium solid ${spaceCadet[300]}`,
    borderWidth: '1px 0px',
    padding: '6px 8px',
    display: 'flex',
    flexDirection: 'column',

    '& .MuiAccordionSummary-root': {
      '&.Mui-expanded': {
        minHeight: 48,
      },
      '& .MuiAccordionSummary-content': {
        fontSize: 14,
        '&.Mui-expanded': {
          margin: '10px 0px',
        },
      },
      '& .MuiAccordionSummary-expandIconWrapper': {
        '& .MuiSvgIcon-root.checked': {
          fontSize: 20,
          color: kiwiGreen[500],
        },
      },
    },

    '& .MuiAccordionDetails-root': {
      marginTop: 4,
      backgroundColor: 'white',
      padding: '4px 8px',
      borderRadius: 6,
      display: 'flex',
      gap: 8,
      justifyContent: 'stretch',
      flexWrap: 'wrap',

      '& > .MuiFormControl-root': {
        padding: '4px 8px',
        '& > .MuiTypography-body1': {
          fontSize: 13,
          lineHeight: '16px',
        },
      },
      '& .MuiCollapse-wrapperInner': {
        padding: '4px 8px',
      },
      '& .MuiTypography-h4': {
        fontSize: 13,
        fontWeight: 600,
        color: spaceCadet[400],
        lineHeight: '16px',
        marginBottom: 4,
      },
      '& > .MuiBox-root': {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',

        '&.actions': {
          justifyContent: 'flex-end',
        },
      },
    },
  },
}));

export default StyledBox;
